<template>

    <div class="card">
      <div class="card-body">
        <h4 class="card-title">{{$t('System Admins')}}</h4>
        <p class="card-description">
          <!--For displaying tabular data. <code>&lt;b-table&gt;</code> supports pagination, filtering, sorting, custom rendering, events, and asynchronous data.-->
        </p>
        <b-container fluid>
          <!-- User Interface controls -->
          <b-row>
            <b-col lg="4" class="my-1">
              <b-form-group
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    :placeholder="$t('Type to Search')"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">{{$t('Clear')}}</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-btn style="float:right;color:white;margin-bottom: 20px" variant="light" v-b-modal.modal-create-user>{{$t('Create System Admin')}}</b-btn>
            </b-col>

          </b-row>

          <!-- Main table element -->
          <b-table
            show-empty
            hover
            small
            stacked="true"
            :items="$store.state.systemAdmins"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filterIncludedFields="filterOn"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
          >
            <template v-slot:cell(name)="row">
              <b-link class="nav-link" :to="'/users/'+row.item.id">{{ row.item.firstName }} {{ row.item.lastName }} </b-link>
            </template>

            <template v-slot:cell(status)="row">
              <label :class="row.item.status === 'Active' ? ' badge badge-success' : 'badge badge-danger'" style="text-align: center;">{{ $t(row.item.status) }}</label>
            </template>

            <template v-slot:cell(actions)="row" >
              <b-button variant="outline-primary" size="sm" @click="editUser(row.item, row.index, $event.target)" class="mr-1">
                {{$t('Edit')}}
              </b-button>
              <b-button variant="outline-danger" size="sm" @click="removeUser(row.item, row.index)">
                {{$t('Remove')}}
              </b-button>
            </template>

            <template v-slot:row-details="row">
              <b-card>
                <ul>
                  <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
                </ul>
              </b-card>
            </template>
          </b-table>

          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            class="my-5"
          ></b-pagination>

        </b-container>
        <b-modal
          id="modal-create-user"
          ref="modal"
          :title="$t('Create User')"
          @show="resetUserModal"
          @hidden="resetUserModal"
          @ok="createUser"
          okVariant="light"
          :ok-title-html="'<span style=color:white;>'+ $t('Submit') +'</span>'"
          :cancel-title="$t('Cancel')"
          header-bg-variant="light"
          header-text-variant="white"
        >

          <form ref="form">
            <div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner" style="padding-top: 40px;">
              <b-spinner
                variant="secondary"
              ></b-spinner>
            </div>
            <b-form-group style="width: 50%;float:left;" id="input-group-2" :label="$t('First Name:')" label-for="input-2">
              <b-form-input
                id="input-2"
                v-model="newUser.firstName"
                :state="$v.newUser.firstName.$dirty ? !$v.newUser.firstName.$error : null"
                required
                placeholder="First Name"
              ></b-form-input>
              <b-form-invalid-feedback id="input-1-live-feedback">
                {{$t('This is a required field')}}.
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group style="width: 50%;float:left;padding-left: 5px" id="input-group-6" :label="$t('Last Name:')" label-for="input-22">
              <b-form-input
                id="input-22"
                v-model="newUser.lastName"
                :state="$v.newUser.lastName.$dirty ? !$v.newUser.lastName.$error : null"
                required
                placeholder="Last Name"
              ></b-form-input>
              <b-form-invalid-feedback id="input-2-live-feedback">
                {{$t('This is a required field')}}.
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              id="input-group-1"
              :label="$t('Email address:')"
              label-for="input-12"
              :description="$t('The email address must be unique for every user.')"
            >
              <b-form-input
                id="input-12"
                v-model="newUser.email"
                required
                :placeholder="$t('Enter Email or Username')"
                :state="$v.newUser.email.$dirty ? !$v.newUser.email.$error : null"
              ></b-form-input>
              <b-form-invalid-feedback id="input-3-live-feedback">
                {{$t('This is a required field')}}.
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              id="input-group-1"
              :label="$t('Password:')"
              label-for="input-1"
              :description="$t('Select a password for the User.')"
            >
              <b-form-input
                id="input-1"
                v-model="newUser.password"
                type="password"
                required
                :placeholder="$t('Enter Password')"
                :state="$v.newUser.password.$dirty ? !$v.newUser.password.$error : null"
              ></b-form-input>
              <b-form-invalid-feedback id="input-4-live-feedback">
                {{$t('Email address is required and must be properly formatted.')}}
              </b-form-invalid-feedback>
            </b-form-group>
          </form>
        </b-modal>
      </div>
    </div>

</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators'
export default {
  data () {
    return {
      loading: false,
      newUser: {
        email: null,
        firstName: null,
        lastName: null,
        password: null,
        status: 'Active',
        role: 'System Admin'
      },
      fields: [
        { key: 'name', label: this.$t('Name'), sortable: true, sortDirection: 'desc', class: 'text-left' },
        { key: 'createdAt', label: this.$t('Created At'), sortable: true, class: 'text-center' },

        {
          key: 'status',
          label: this.$t('Status'),
          // formatter: (value, key, item) => {
          //   return value ? 'Yes' : 'No'
          // },
          sortable: true,
          class: 'text-center'
          // sortByFormatted: true,
          // filterByFormatted: true
        },
        { key: 'actions', label: this.$t('Actions'), class: 'text-center' }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: []
    }
  },
  validations: {
    newUser: {
      firstName: {
        required
      },
      lastName: {
        required
      },
      email: {
        required
      },
      password: {
        required,
        minLength: minLength(6)
      }
    }
  },
  computed: {
    sortOptions () {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    }
  },
  mounted () {
    // Set the initial number of items
    this.$store.dispatch('fetchSystemAdmins')
    this.totalRows = this.$store.state.systemAdmins.length
    // this.mapUsers()
  },
  methods: {
    editUser (item, index, button) {
      this.$router.push('/users/' + item.id)
    },
    removeUser (item, index, button) {
      this.$swal({
        title: self.$t('Are you sure?'),
        text: self.$t('Deleting this user cannot be undone!'),
        showConfirmButton: true,
        showCancelButton: true
      }).then(function (value) {
        if (value.value) {
          const removeUser = this.$firebase.functions().httpsCallable('removeUser')
          removeUser(item.id).then(function (result) {
            // success or error handling
            if (result.data) {
              self.$swal({
                title: self.$t('User Deleted!'),
                type: 'success',
                timer: 2000,
                showConfirmButton: false
              })
            }
            self.loading = false
          })
        }
      })
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    createUser (e) {
      e.preventDefault()

      this.$v.newUser.$touch()
      if (this.$v.newUser.$anyError) {
        return
      }

      this.loading = true
      let self = this

      const createAdminUser = this.$firebase.functions().httpsCallable('createUser')
      createAdminUser(this.newUser).then(function (result) {
        // success or error handling
        if (result.data.errorInfo) {
          self.$swal({
            title: self.$t('There was an error!'),
            text: result.data.errorInfo.message,
            type: 'error',
            timer: 0,
            showConfirmButton: true
          })
        } else {
          self.$store.dispatch('fetchSystemAdmins')
          self.$swal({
            title: self.$t('User Created!'),
            type: 'success',
            timer: 2000,
            showConfirmButton: false
          }).then(function (result) {
            self.$refs.modal.hide()
          })
        }
        self.loading = false
      })
    },
    resetUserModal () {
      this.newUser.email = null
      this.newUser.firstName = null
      this.newUser.lastName = null
      this.$v.$reset()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdminUsers.vue